import { isMobile } from "react-device-detect";

export const screenWidth = (pixels) =>
  (window.outerWidth / 1366) * pixels * (isMobile ? 3 : 1);

export const screenHeight = (pixels) =>
  (window.outerHeight / 694) * pixels * (isMobile ? 3 : 1);
